export default __webpack_public_path__ + "static/media/Copy of 08-Get-Certified.364ca0be.jpg";